import { render, staticRenderFns } from "./employeeView.vue?vue&type=template&id=afc98518&scoped=true"
import script from "./employeeView.vue?vue&type=script&lang=js"
export * from "./employeeView.vue?vue&type=script&lang=js"
import style0 from "./employeeView.vue?vue&type=style&index=0&id=afc98518&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afc98518",
  null
  
)

export default component.exports